'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTheme = exports.buildThemePropTypes = undefined;

var _lodash = require('lodash');

var _fp = require('lodash/fp');

var _propTypes = require('prop-types');

function removeFromProd(nonProdArg, prodArg) {
  if (process.env.NODE_ENV !== 'production') {
    return nonProdArg;
  }
  return prodArg;
}

/**
 * Creates the theme proptypes object in a non-prod build, returns undefined in prod.
 * @param {Object} propTypes An object definining the expected propTypes within the theme.
 */
var buildThemePropTypes = exports.buildThemePropTypes = (0, _fp.compose)(removeFromProd);

/**
 * Performs propTypes validations on the theme actually being used by a styled component
 * @param {String} componentName  The component's displayName. Must be passed in as `this` will be
 *                                `undefined`.
 * @param {Object} themePropTypes Defines the expected propTypes to be found in the theme.
 * @param {Object} props          The component's props.
 */
var validateTheme = exports.validateTheme = removeFromProd((0, _lodash.curry)(function (componentName, themePropTypes, props) {
  (0, _propTypes.checkPropTypes)({ theme: (0, _propTypes.shape)(themePropTypes).isRequired }, props, 'theme', componentName);
}), _lodash.noop);


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-theme-validator/dist/index.js
// module id = 314
// module chunks = 2